var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ItpButton", {
    style: {
      cursor: _vm.isDisabled ? "not-allowed" : null
    },
    attrs: {
      dropdownItem: _vm.dropdownItem,
      text: _vm.noText ? null : _vm.messages.text,
      icon: _vm.noIcon ? null : "fa-trash",
      variant: _vm.dropdownItem ? "default" : _vm.variant,
      spinning: _vm.actions.delete.isRunning,
      disabled: _vm.isDisabled,
      size: _vm.size,
      tooltip: _vm.currentTooltip
    },
    on: {
      click: function($event) {
        $event.preventDefault()
        $event.stopPropagation()
        return _vm.evh_7315092382398562_clickPreventStop($event, {})
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }